import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const uploadPositioningDeviceInfosFile = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/uploadpositioningdeviceinfosfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const quicklyGenerateVideoCertificateForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/quicklygeneratevideocertificateforyiliu' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const generateMergencyAlarmCertificate = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generateemergencyalarmcertificate/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const quicklyGenerateInsuranceVideoCommitment = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/quicklygenerateinsurancevideocommitment' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getMyPositioningdeviceinfoForUnbindTerminalnum = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/getmypositioningdeviceinfoforunbindterminalnum' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const generateInsuranceVideoCommitment = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generateinsurancevideocommitment/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '/' + params.isall + '/' + params.manufacturer + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const quicklyGenerateVideoCertificate = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/quicklygeneratevideocertificate' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const quicklyGenerateCertificateForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/quicklygeneratecertificateforyiliu' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const modifyPositioningDeviceInfosFile = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/modifypositioningdeviceinfosfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const generateVideoCertificateForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatevideocertificateforyiliu/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '/' + params.adas + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const generateMergencyAlarmCertificateForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generateemergencyalarmcertificateforyiliu/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindSimInfos = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/bindsiminfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindSimInfos = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/unbindsiminfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const reopeningState = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/reopeningstate/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/changeinstaller/' + params.id + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchChangeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/batchchangeinstaller/' + params.ids + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const generateVideoCommitment = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatevideocommitment/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.governmentAgency + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const generateStarLightAlarmForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatestarlightalarmforyiliu/' + params.id + '/' + params.certificateArea + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindTerminalnum = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/bindterminalnum/' + params.id + '/' + params.terminalNum + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const generateVideoCertificate = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatevideocertificate/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '/' + params.adas + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const generateCertificate = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatecertificate/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const quicklyGenerateCertificate = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/quicklygeneratecertificate' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const unBindTerminalnum = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/unbindterminalnum/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getTerminalnumForManufacturer = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/getterminalnumformanufacturer/' + params.manufacturer + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyServiceDatetime = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/modifyservicedatetime/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const bindPositioningDeviceFittings = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/bindpositioningdevicefittings/' + params.id + '/' + params.positioningdevicefittingsid + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const generateCertificateForYILIU = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/generatecertificateforyiliu/' + params.id + '/' + params.certificateArea + '/' + params.setupDatetime + '/' + params.printDatetime + '/' + params.effectiveType + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyPositioningdeviceinfo = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/getmypositioningdeviceinfo' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const supplementaryRenewalOrder = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdeviceinfo/supplementaryrenewalorder/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

